var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasContent)?_c('span',{staticClass:"title-question-icon",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggleHelp()}}},[_c('iquestion')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }